var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"brands-page page 404 notfound"},[_c('div',{staticClass:"d-flex flex-column justify-center align-center",staticStyle:{"min-height":"50vh"}},[_c('h2',{staticClass:"text-center"},[_c('b',[_vm._v(_vm._s(_vm.content))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }